var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73684 4C9.21636 4 8.70758 4.15434 8.27482 4.4435C7.84205 4.73266 7.50476 5.14366 7.30558 5.62452C7.1064 6.10538 7.05429 6.6345 7.15583 7.14497C7.25737 7.65545 7.508 8.12435 7.87603 8.49239C8.24407 8.86042 8.71297 9.11105 9.22345 9.21259C9.73392 9.31413 10.263 9.26202 10.7439 9.06284C11.2248 8.86366 11.6358 8.52637 11.9249 8.09361C12.2141 7.66085 12.3684 7.15206 12.3684 6.63158C12.3684 5.93364 12.0912 5.26429 11.5976 4.77077C11.1041 4.27725 10.4348 4 9.73684 4V4ZM9.73684 8.21053C9.42456 8.21053 9.11928 8.11792 8.85963 7.94443C8.59997 7.77093 8.39759 7.52433 8.27808 7.23582C8.15858 6.9473 8.12731 6.62983 8.18823 6.32354C8.24916 6.01726 8.39954 5.73591 8.62036 5.51509C8.84118 5.29427 9.12252 5.14389 9.4288 5.08297C9.73509 5.02205 10.0526 5.05332 10.3411 5.17282C10.6296 5.29233 10.8762 5.49471 11.0497 5.75436C11.2232 6.01402 11.3158 6.31929 11.3158 6.63158C11.3158 7.05034 11.1494 7.45195 10.8533 7.74806C10.5572 8.04417 10.1556 8.21053 9.73684 8.21053V8.21053ZM14.4737 14V13.4737C14.4737 12.4966 14.0855 11.5595 13.3946 10.8686C12.7037 10.1776 11.7666 9.78947 10.7895 9.78947H8.68421C7.7071 9.78947 6.77 10.1776 6.07908 10.8686C5.38816 11.5595 5 12.4966 5 13.4737V14H6.05263V13.4737C6.05263 12.7757 6.32989 12.1064 6.8234 11.6129C7.31692 11.1194 7.98627 10.8421 8.68421 10.8421H10.7895C11.4874 10.8421 12.1568 11.1194 12.6503 11.6129C13.1438 12.1064 13.4211 12.7757 13.4211 13.4737V14H14.4737Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c7c4087da261ee0989b49674ba2aaab3.svg";
export { ForwardRef as ReactComponent };